import SuggestionKeywords from './SuggestionKeywords';

export default SuggestionKeywords;
